function Validator_document(element) {
    this.$element = $(element);

    this.selectors = {
	    formParent: 'form[data-i4-decorator="Validator_form"]',
	    elementDocument: '.js-element-document',
	    hiddenAddType: '.js-hidden-add-type',
	    hiddenUploadedFile: '.js-hidden-uploaded-file',
	    hiddenChoosedFile: '.js-hidden-choosed-file',
	    currentPreview: '.js-current-preview'
    };

    this.data = {
	    required: 'required',
	    messageFail: 'message-fail',
		validateOnSubmit: 'validate-on-submit'
    };

    this.triggers = {
	    validate: 'i4:validate',
	    updateView: 'i4:updateView',
	    refresh: 'i4:refresh'
    };

    this.init = function() {

	    // console.log('init - document');

	    this.$formParent = this.$element.parents(this.selectors.formParent);
	    this.$elementDocument = this.$element.find(this.selectors.elementDocument);
	    this.$hiddenAddType = this.$element.find(this.selectors.hiddenAddType);
	    this.$hiddenUploadedFile = this.$element.find(this.selectors.hiddenUploadedFile);
	    this.$hiddenChoosedFile = this.$element.find(this.selectors.hiddenChoosedFile);
	    this.$currentPreview = this.$element.find(this.selectors.currentPreview);

	    this.dataRequired = this.$element.data(this.data.required);

		this.$formParent.trigger(this.triggers.refresh);

		this.$element.on(this.triggers.validate, this.validate.bind(this));
		this.$elementDocument.on('i4:change', this.$elementChange.bind(this));

		if (!(this.$formParent.length && this.$formParent.data(this.data.validateOnSubmit))) {
			this.validate();
		}
    };

    this.$elementChange = function() {
	    this.validate();

	    this.$formParent.trigger(this.triggers.updateView);
    };

    this.validate = function() {
	    var isValid = false;

		this.value = false;
	    if (this.$hiddenAddType.val() === 'upload') {
	        this.value = this.$hiddenUploadedFile.val();
	    } else if (this.$hiddenAddType.val() === 'choose') {
		    this.value = this.$hiddenChoosedFile.val();
		}

		// console.log("this.$hiddenAddType.val()", this.$hiddenAddType.val());
		// console.log("this.value", this.value);
		// console.log("this.$currentPreview", this.$currentPreview);

		if (this.value != '' || this.$currentPreview.length) {
			isValid = true;
		}

		this.$element.removeClass('invalid');
		this.$element.removeClass('valid');

		if (isValid) {
			this.$element.addClass('valid');
		} else if (this.dataRequired) {
			this.$element.addClass('invalid');
		}
    };
}
